import { useEffect, useState } from 'react';

import { useAllEmployees } from '~/data/employees';
import { useSelectedEmployeeId } from '~/hooks/employee';
import { useVisible } from '~/hooks/useVisible';

import {
  EmplHistoryDetailType,
  getEmplDetailHistory,
} from './components/EmplDetailHistory/data';
import { EmplHistoryType, getEmplHistory } from './components/EmplHistory/data';
import {
  EmplOtherHistoryType,
  getEmplOtherHistory,
} from './components/EmplOtherHistory/data';

export type UseScheduleHistoryOutput = {
  emplHistory: EmplHistoryType[];
  emplDetailHistory: EmplHistoryDetailType[];
  emplOtherHistory: EmplOtherHistoryType[];
  isDialogOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
};

export const useScheduleHistory = () => {
  const [emplHistory, setEmplHistory] = useState<EmplHistoryType[]>([]);
  const [emplDetailHistory, setEmplDetailHistory] = useState<
    EmplHistoryDetailType[]
  >([]);
  const [emplOtherHistory, setEmplOtherHistory] = useState<
    EmplOtherHistoryType[]
  >([]);
  const { selectedEmployeeId } = useSelectedEmployeeId();
  const empId = String(selectedEmployeeId);

  const { allEmployees } = useAllEmployees();
  const fEmpEmplId = allEmployees[parseInt(empId)];

  useEffect(() => {
    (async () => {
      setEmplHistory(await getEmplHistory(empId));
    })();
    if (!!fEmpEmplId?.fEmpEmplId) {
      (async () => {
        setEmplDetailHistory(
          await getEmplDetailHistory(empId, fEmpEmplId?.fEmpEmplId),
        );
      })();
    }
    (async () => {
      setEmplOtherHistory(await getEmplOtherHistory(empId));
    })();
  }, [empId, fEmpEmplId?.fEmpEmplId]);

  const {
    isVisible: isDialogOpen,
    show: openDialog,
    hide: closeDialog,
  } = useVisible();

  return {
    emplHistory,
    emplDetailHistory,
    emplOtherHistory,
    isDialogOpen,
    openDialog,
    closeDialog,
  };
};
